import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa"; // Import all Font Awesome icons
import { HiOutlineDocumentText, HiOutlineTrash, HiPlus,HiX } from "react-icons/hi";
import { toast } from "react-toastify";

import Select from "react-select";
import axios from "../../utils/axios";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import { getUser } from "../../utils/Common";
import { useNavigate, useParams } from "react-router-dom";

const RoomFacilities = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [isMiniSidebar, setMiniSidebar] = useState(false);
  const { hotel_id } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [propData, setPropData] = useState([]);
  const [facilityList, setFacilityList] = useState([]);
  const [roomList, setRoomList] = useState([]);
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editingFacility, setEditingFacility] = useState(null);
  const [editingRoom, setEditingRoom] = useState(null);
  
  const [newFacility, setNewFacility] = useState({
    ROOM_ID: "",
    NAME_FCT: "",
    ICON_ROOM_FCT: "",
  });

  const getDetailProperty = async (hid) => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/detail/hotel/${hid}`);
      if (response.status === 200) setPropData(response.data);
    } catch (err) {
      console.error("Error fetching property details:", err);
    } finally {
      setLoading(false);
    }
  };

  const getRoomSelect = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/select/rooms/${hotel_id}`);
      if (response.status === 200) setRoomList(response.data);
    } catch (err) {
      console.error("Error fetching room list:", err);
    } finally {
      setLoading(false);
    }
  };

  const getFacilityList = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/room/facilities/${hotel_id}`);
      if (response.status === 200){
        setFacilityList(response.data.data);
        console.log(response.data.data)
      }
    } catch (err) {
      console.error("Error fetching facilities list:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddFacility = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
  
    try {
      // Prepare the payload
      const payload = { HOTEL_ID: hotel_id, ...newFacility };
  
      // Make an API call to insert the facility
      const response = await axios.post(`/api/insert/room/facility`, payload);
  
      if (response.status === 201) {
        // Notify the user of success
        toast.success("Facility added successfully!");
  
        // Refresh the facility list to include the newly added facility
        await getFacilityList();
  
        // Reset the form to default values
        setNewFacility({ ROOM_ID: "", NAME_FCT: "", ICON_ROOM_FCT: "" });
  
        // Close the Add Modal
        setAddModalOpen(false);
      } else {
        // Handle unexpected response
        toast.error("Failed to add facility. Unexpected response from the server.");
      }
    } catch (err) {
      console.error("Error adding facility:", err);
  
      // Show appropriate error messages based on the error response
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(`Failed to add facility: ${err.response.data.message}`);
      } else {
        toast.error("An error occurred while adding the facility. Please try again.");
      }
    }
  };

  const  doSettingFac = async (room,facility) => {
    console.log(room)
    setEditingRoom(room);
    setEditingFacility(facility);
    setEditModalOpen(true)
  }

  const handleEditFacility = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        UID:userData.id,
        ID_ROOM_FCT: editingFacility.facility_id,
        ROOM_ID: editingFacility.ROOM_ID|| editingRoom.ID_ROOM,
        NAME_FCT: editingFacility.NAME_FCT || editingFacility.facility_name ,
        ICON_ROOM_FCT: editingFacility.ICON_ROOM_FCT || editingFacility.facility_icon,
      };
      // console.log(payload);
      // console.log(editingFacility);
      const response = await axios.post(`/api/update/room/facility`, payload);
      if (response.status === 200) {
        toast.success("Facility updated successfully!");
        getFacilityList();
        setEditModalOpen(false);
      } else {
        toast.error("Failed to update facility.");
      }
    } catch (err) {
      console.error("Error updating facility:", err);
      toast.error("An error occurred while updating the facility.");
    }
  };
  
  const handleDeleteFacility = async (facilityId) => {
    if (window.confirm("Are you sure you want to delete this facility?")) {
      try {
        const response = await axios.get(`/api/delete/room/facility/${facilityId}`);
        if (response.status === 200) {
          toast.success("Facility deleted successfully.");
          getFacilityList(hotel_id);
        } else {
          toast.error("Failed to delete facility.");
        }
      } catch (err) {
        console.error("Error deleting facility:", err);
        toast.error("An error occurred while deleting the facility.");
      }
    }
  };
  
  useEffect(() => {
    var userHID = localStorage.getItem("hid");
    const userSession = getUser(); // Call getUser to fetch user data from localStorage
    if (userSession) {
      setUserData(userSession); // Store user data in the state if it exists
      getDetailProperty(userHID);
      getRoomSelect();
      getFacilityList();
    } else {
      navigate('/'); // Optionally clear the user data if not found
    }
  }, []);

  // Generate dropdown options for icons
  const renderIconOptions = () => {
    return Object.keys(FaIcons).map((iconName) => {
      const IconComponent = FaIcons[iconName];
      return {
        value: iconName,
        label: (
          <div className="flex items-center space-x-2">
            <IconComponent size={16} />
            <span>{iconName}</span>
          </div>
        ),
      };
    });
  };
  

  return (
    <div className="flex h-screen bg-gray-200">
      <Sidebar
        setMiniSidebar={setMiniSidebar}
        isMiniSidebar={isMiniSidebar}
        propertyID={propData.ID_HOTEL || "Loading..."}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar setMiniSidebar={setMiniSidebar} isMiniSidebar={isMiniSidebar} />
        <main className="flex-1 p-5 overflow-y-auto bg-gray-100">
          <div className="mb-4 text-sm text-[#101827]">
            <span>Room Facilities</span> &gt; <span>{propData.NAME_HOTEL}</span>
          </div>

          <section className="bg-white rounded shadow-md py-4 px-6 text-[#101827] mb-6">
            {isLoading ? (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#0f1827] mb-4"></div>
                  <p className="text-gray-700">Load Data...</p>
                </div>
            </div>
            ) : facilityList.length === 0 ? ( // Check if facilityList is empty
              <p className="text-center text-sm text-gray-500">No Record. Please add facilities first.</p>
            ) : (
              facilityList.map((room) => (
                <div key={room.ID_ROOM} className="mb-6">
                  <h2 className="text-sm font-bold mb-4">{room.ROOM_NAME}</h2>

                  {/* Check if room.facilities is empty */}
                  {room.facilities.length === 0 ? (
                    <p className="text-center text-gray-500">No facilities available for this room.</p>
                  ) : (
                    <table className="w-full border-collapse border border-gray-300">
                      <thead>
                        <tr>
                          <th className="border border-gray-300 p-2 text-xs text-left w-16">Icon</th>
                          <th className="border border-gray-300 p-2 text-xs text-left">Facility Name</th>
                          <th className="border border-gray-300 p-2 text-xs text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {room.facilities.map((facility, index) => (
                          <tr className="text-xs" key={index}>
                            <td className="border border-gray-300 p-4 flex items-center justify-center">
                              {FaIcons[facility.facility_icon] ? (
                                React.createElement(FaIcons[facility.facility_icon], { size: 30 })
                              ) : (
                                "Unknown Icon"
                              )}
                            </td>
                            <td className="border border-gray-300 p-2">{facility.facility_name}</td>
                            <td className="border border-gray-300 p-2">
                              <button
                                className="text-blue-500 hover:text-blue-700"
                                title="Edit Rate"
                                onClick={() => doSettingFac(room, facility)}
                              >
                                <HiOutlineDocumentText size={20} />
                              </button>
                              <button
                                className="text-red-500 hover:text-red-700"
                                onClick={() => handleDeleteFacility(facility.facility_id)}
                                title="Delete Facility"
                              >
                                <HiOutlineTrash size={20} className="mx-2" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              ))
            )}
          </section>

        </main>
      </div>

      <button className="fixed bottom-10 right-10 bg-blue-600 text-white p-4 rounded-full shadow-lg hover:bg-blue-500 transition" onClick={() => setAddModalOpen(true)} title="Add Facility">
        <HiPlus size={24} />
      </button>

      {isAddModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
           
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-sm font-semibold">New Facility  </h4>
              <HiX 
                size={24} 
                onClick={() => setAddModalOpen(false)} 
                className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
              />
            </div>

            <form onSubmit={handleAddFacility}>
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Choose Room</label>
                <Select
                  options={roomList}
                  getOptionLabel={(e) => e.label}
                  getOptionValue={(e) => e.value}
                  onChange={(e) => setNewFacility({ ...newFacility, ROOM_ID: e.value })}
                  placeholder="Select Room"
                  isClearable
                  className="text-xs"
                />
              </div>
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Facility Name</label>
                <input
                  type="text"
                  value={newFacility.NAME_FCT}
                  onChange={(e) => setNewFacility({ ...newFacility, NAME_FCT: e.target.value })}
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
                <div className="mb-4">
                    <label className="block text-xs font-medium mb-1">Icon</label>
                    <Select
                        options={renderIconOptions()}
                        onChange={(e) => setNewFacility({ ...newFacility, ICON_ROOM_FCT: e.value })}
                        placeholder="Select Icon"
                        isClearable
                        className="text-xs"
                    />
                </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  className="bg-gray-300 px-4 py-2 rounded mr-2 text-xs"
                  onClick={() => setAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 px-4 py-2 rounded text-white text-xs"
                >
                  Add Facility
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      
      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg">
            <div className="flex justify-between items-center mb-4">
              <h4 className="text-sm font-semibold">Edit Facility  </h4>
              <HiX 
                size={24} 
                onClick={() => setEditModalOpen(false)} 
                className="text-gray-800 hover:text-gray-700 focus:outline-none cursor-pointer"
              />
            </div>
            <form onSubmit={handleEditFacility}>
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Room</label>
                <Select
                  options={roomList}
                  defaultValue={roomList.find(
                    (room) => room.value === editingRoom?.ID_ROOM
                  )} // Pre-select the current room
                  getOptionLabel={(e) => e.label}
                  getOptionValue={(e) => e.value}
                  onChange={(e) =>
                    setEditingFacility({ ...editingFacility, ROOM_ID: e.value })
                  }
                  placeholder="Select Room"
                  isClearable
                  className="text-xs"
                />
              </div>
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Facility Name</label>
                
                <input
                  type="text"
                  defaultValue={editingFacility?.facility_name || ""}
                  onChange={(e) =>
                    setEditingFacility({ ...editingFacility, NAME_FCT: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2 text-xs"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-xs font-medium mb-1">Icon</label>
                <Select
                  options={renderIconOptions()}
                  defaultValue={renderIconOptions().find(
                    (icon) => icon.value === editingFacility?.facility_icon
                  )} // Pre-select the current icon
                  onChange={(e) =>
                    setEditingFacility({ ...editingFacility, ICON_ROOM_FCT: e.value })
                  }
                  placeholder="Select Icon"
                  isClearable
                  className="text-xs"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  className="bg-gray-300 px-4 py-2 rounded mr-2 text-xs"
                  onClick={() => setEditModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-blue-600 px-4 py-2 rounded text-white text-xs"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </div>
  );
};

export default RoomFacilities;
